/**
 * Shared EA journey client id.
 * Personalize / Evaluate / Execute (including Use Case Profile, Scoring Rationale,
 * and ROI Model) must all use this so Personalization Strength stays consistent.
 */
export const EA_CLIENT_ID = '300';
